import { Component } from '@verndale/core';
import '../../scss/modules/accordion.scss';
import Player from '@vimeo/player';

class Masthead extends Component {
  private playing = false;

  setupDefaults() {
    this.dom = {
      container: this.el.querySelector('.masthead__video--video') as HTMLElement
    };
  }

  addListeners() {
    window.addEventListener('mousemove', this.initVimeoPlayer.bind(this), { once: true });
    window.addEventListener('touchstart', this.initVimeoPlayer.bind(this), { once: true });
  }

  initVimeoPlayer() {
    const container = this.dom.container as HTMLElement;
    const vimeoId = container.dataset.videoId || '';
    if (this.playing || vimeoId?.length < 1) return;
    const options01 = {
      id: parseInt(vimeoId),
      allow: 'autoplay; fullscreen; picture-in-picture',
      width: window.innerWidth,
      autoplay: true,
      background: true,
      byline: false,
      controls: false
    };

    if (this.dom.container instanceof HTMLElement) {
      if (this.playing) return;
      const player = new Player(this.dom.container, options01);

      player.ready().then(() => {
        player.play();
        player.on('progress', data => {
          if (data.percent > 0.1) {
            this.playing = true;
            this.el.classList.add('is-playing');
            player.off('progress');
          }
        });
      });
    }
  }
}

export default Masthead;
